import Siema from 'siema';

/* eslint-disable indent */
export default class HandleReduWizardSlider {
    constructor(element, tabId) {
        this.element = element.querySelector('.js--reduwizard-slider-container');
        this.next = element.querySelector('.js--reduwizard-slider--next');
        this.previous = element.querySelector('.js--reduwizard-slider--previous');
        this.tabTrigger = document.querySelector('.js-tab[data-tab-id="' + tabId + '"]');
        this.onInit = this.onInit.bind(this);
        this.count = this.element.getElementsByClassName('reduwizard-item').length;
        this.onChange = this.onChange.bind(this);
        this.mySiema = new Siema({
            selector: this.element,
            duration: 200,
            draggable: true,
            perPage: {
                481: 3,
                1024: 4,
            },
            onChange: this.onChange,
            onInit: this.onInit,
        });
        this._setDOMReferences();
        this.checkLastChild();
    }

    _setDOMReferences() {
        this.next.addEventListener('click', () => this.mySiema.next());
        this.previous.addEventListener('click', () => this.mySiema.prev());

        if (this.tabTrigger) {
            this.tabTrigger.addEventListener('click', () => {
                this.mySiema.resizeHandler()
            });
        }
    }
    checkLastChild() {
        let lastChildCollector = this.element.querySelectorAll('.reduwizard-item');
        let lastChild = lastChildCollector[lastChildCollector.length-1];
        lastChild.classList.add('reduwizard-item--last');
    }
    onInit() {
        // On slider initialization we set the previous button to disabled.
        this.previous.disabled = true;

        // We check if there are 4 or more products being displayed. If not, it's not possible to slide so
        // we disable the next button as well.
        if (this.count <= 4) {
            this.next.disabled = true;
        }

    }
    onChange() {
        const index = this.mySiema.currentSlide;
        this.previous.disabled = (0 === index);
        this.next.disabled = (
            index === this.mySiema.innerElements.length + 1 ||
            index + this.mySiema.perPage >= this.mySiema.innerElements.length
        );
    }
}
